import role from 'api/role'

export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS'

const getRoles = () => (dispatch) =>
  role
    .getRoles()
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch({ type: GET_ROLES_SUCCESS, payload: data.results })
      } else {
        throw data
      }
    })
    .catch((err) => {
      console.error('reducer roles', err)

      dispatch({ type: GET_ROLES_SUCCESS, payload: [] })
    })

export default {
  getRoles,
}
